module.exports = __webpack_public_path__ + "static/media/thumb.6f47f9f7.jpg";